export const AdProviders = {
  adMob: 'admob',
  appLovin: 'applovin',
  fallback: 'fallback',
} as const;

export const AdProviderTypes = Object.values(AdProviders) as [string, ...string[]];

export type AdProviders = (typeof AdProviders)[keyof typeof AdProviders];
